import { connect } from 'react-redux'
import { changeLoading , snackAction , logout } from '../modules/main'

import Main from '../components/Main'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'

const mapDispatchToProps = {
	changeLoading,
	snackAction,
	logout
}

const mapStateToProps = (state) => ({
  main : state.main,
  translate: getTranslate(state.locale)
})

export default connect(mapStateToProps, mapDispatchToProps)(Main)



// WEBPACK FOOTER //
// ./src/routes/Main/containers/MainContainer.js